var map = {
	"./board_layout_1.png": "11ab",
	"./board_layout_2.png": "00cc",
	"./board_layout_3.png": "98bb",
	"./board_layout_4.png": "047b",
	"./board_layout_5.png": "9baf",
	"./board_layout_6.png": "ce7d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5213";